import { combineReducers } from 'redux';

import apiError from './apiError';
import countries from './countries';
import data from './data';
import isFetching from './isFetching';

/**
 * @typedef {{
 *  apiError: string,
 *  isFetching: boolean,
 *  countries: Array<import('modules/statistics/types').DealersCountriesReducer>,
 *  data: import('modules/statistics/types').AllDealersStatisticsReducer,
 * }} StatisticsTotalReducer
 */

export default combineReducers({
  data,
  apiError,
  countries,
  isFetching,
});
